import { defineComponent as _defineComponent } from 'vue'
import logApi from '@/api/log';
import { computed, ref, onMounted } from 'vue';
import tablePager from '@/components/table-pager.vue';

type logItemType = {
	logId: number;
	logType: string;
	logLevel: number;
	logContent: string;
	createTime: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose: __expose }) {
  __expose();

const count = ref(0);

const list = ref<logItemType[]>([
	{
		logId: 1,
		logType: 'error',
		logLevel: 1,
		logContent: '无日志信息',
		createTime: '',
	},
]);

const logColor = computed(() => {
	return function (logType: string) {
		switch (logType) {
			case 'error':
				return 'red';
			case 'process':
				return 'white';
			case 'operate':
				return 'green';
			default:
				return 'white';
		}
	};
});

async function load_table(page: number, pageSize: number) {
	const res: any = await logApi.get_log(page, pageSize);
	count.value = res.count;
	list.value = res.list;
}

onMounted(async () => {
	load_table(1, 10);
});

const __returned__ = { count, list, logColor, load_table, tablePager }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})